import React from "react";

import classes from "./SuggestedVideo.module.css";
import { formatViews } from "../../utility";

export default function Result(props) {
  return (
    <div
      className={classes.Result}
      onClick={() => props.videoFromSuggested(props.videoId, props.channelId)}
    >
      <div className={classes.Thumbnail}>
        <img src={props.imgSrc} alt="Thumbnail" />
        <span className={classes.WatchLater}>
          <i className="fas fa-clock" />
        </span>
        <span className={classes.Duration}>{props.duration}</span>
      </div>
      <div className={classes.Info}>
        <h3>{props.title}</h3>
        <div>{props.channelName}</div>
        <div>
          <span style={{ textTransform: "uppercase" }}>
            {formatViews(props.viewsCount)}
          </span>{" "}
          views
        </div>
        <span className={["fas fa-ellipsis-v", classes.OptBtn].join(" ")} />
      </div>
    </div>
  );
}
